import $ from 'jquery';

/**
 * In-page dialog for a checkout error message. The site's template provides the markup:
 * a .modal-container with an h3 title, a p.message, and .back / .close elements that dismiss it.
 * The template's title is the default; open() can replace it for one message.
 */
export class ErrorModal {
	constructor(element) {
		this.element = $(element);
		this.titleElement = this.element.find('h3');
		this.defaultTitle = this.titleElement.text();
		this.element.find('.back, .close').on('click', this.close.bind(this));
	}

	open(message, title = null) {
		this.titleElement.text(title || this.defaultTitle);
		this.element.find('p.message').text(message);
		this.element.css('display', 'block');
	}

	close(event) {
		if (event) {
			event.preventDefault();
		}
		this.element.css('display', 'none');
	}
}
